import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],

  // Performance monitoring: capture 100% in dev, 20% in prod
  tracesSampleRate: import.meta.env.DEV ? 1.0 : 0.2,

  // Session replay: capture 10% of sessions, 100% on error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  // Tag real production traffic as 'production'. The deployed build has been
  // resolving import.meta.env.MODE to 'development', which hid prod events on
  // the Sentry "production" environment. Derive from the host as a safety net.
  environment:
    typeof window !== 'undefined' && window.location.hostname === 'carousel.corestudio.ai'
      ? 'production'
      : import.meta.env.MODE,

  beforeSend(event, hint) {
    const error = hint.originalException;
    if (error instanceof Error) {
      const msg = error.message;
      // These DOM-mutation errors come from browser auto-translation (and
      // DOM-mutating extensions) rewrapping React-managed text nodes. The real
      // fix is `notranslate` in index.html (<html translate="no"> + meta), which
      // stops the dominant source. We still drop them here to silence residual
      // noise from third-party extensions we cannot control. If you want to
      // confirm the translate fix landed, temporarily remove this block.
      if (
        msg.includes("Failed to execute 'removeChild' on 'Node'") ||
        msg.includes("Failed to execute 'insertBefore' on 'Node'") ||
        msg.includes("Failed to execute 'appendChild' on 'Node'") ||
        msg.includes('The object can not be found here')
      ) {
        return null;
      }
      if (msg.includes('Sentry Test Error')) {
        return null;
      }
      // WebView / in-app browser injected code (Instagram, Facebook, Android autofill)
      if (
        msg.includes('webkit.messageHandlers') ||
        msg.includes('Java object is gone') ||
        msg.includes('setContactAutofillValuesFromBridge')
      ) {
        return null;
      }
    }
    return event;
  },
});

export default Sentry;
